<template>
  <div>
    <vue-headful title="Maak je profiel compleet" />
    <Header
      page_title="Maak je profiel compleet"
      menuClass="invisible"
      :link="{ name: 'register-1' }"
      :do-not-show-all="!this.prevRoute || this.prevRoute.name !== 'applicant-edit'"
    />
    <div class="pt-3 px-4 mx-2 pb-4 questionnaire">
      <div class="container-fluid px-0 pb-1 mb-2">
        <form @submit.prevent="onSubmit">
          <div class="step-question">
            <button type="submit" ref="submit" hidden>submit</button>
            <div class="title text-14 text-center">
              Ervaring binnen het onderwijs
            </div>
            <div class="icon">
              <div class="svg">
                <svg
                  viewBox="0 0 200 120"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                >
                  <g
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <g>
                      <path
                        d="M0,0 L200,0 L200,120 L0,120 L0,0 Z M53,112.882353 L146.83114,112.882353 C146.83114,93.0650766 125.826324,77 99.9155699,77 C74.0048161,77 53,93.0650766 53,112.882353 Z M99.6680097,76.5294118 C117.157768,76.5294118 131.336019,62.3078685 131.336019,44.7647059 C131.336019,27.2215432 117.157768,13 99.6680097,13 C82.1782509,13 68,27.2215432 68,44.7647059 C68,62.3078685 82.1782509,76.5294118 99.6680097,76.5294118 Z"
                        fill="#FFFFFF"
                        fill-rule="nonzero"
                      />
                      <path
                        d="M53,112.882353 C53,93.0650766 74.0048161,77 99.9155699,77 C125.826324,77 146.83114,93.0650766 146.83114,112.882353 L53,112.882353 Z"
                        stroke="#625A55"
                        stroke-width="4.2"
                      />
                      <ellipse
                        stroke="#625A55"
                        stroke-width="4.2"
                        cx="99.6680097"
                        cy="44.7647059"
                        rx="31.6680097"
                        ry="31.7647059"
                      />
                      <path
                        d="M148.808696,30.4085625 L161.95566,84.234468"
                        stroke="#625A55"
                        stroke-width="4.2"
                        fill="#D8D8D8"
                        fill-rule="nonzero"
                        stroke-linecap="round"
                        transform="translate(155.382178, 57.321515) rotate(45.000000) translate(-155.382178, -57.321515) "
                      />
                      <polyline
                        stroke="#625A55"
                        stroke-width="4.2"
                        points="81.7357866 79.4705882 99.9155699 93 117.508909 79.4705882"
                      />
                      <g
                        transform="translate(91.000000, 42.000000)"
                        fill="#625A55"
                        fill-rule="nonzero"
                      >
                        <circle cx="4" cy="4" r="4" />
                        <circle cx="26" cy="4" r="4" />
                      </g>
                      <path
                        d="M95.1844298,59.3411731 C100.851096,64.6352907 106.517763,65.7252561 112.18443,62.6110692"
                        stroke="#625A55"
                        stroke-width="4"
                        stroke-linecap="round"
                        transform="translate(103.684430, 61.841173) rotate(-8.000000) translate(-103.684430, -61.841173) "
                      />
                    </g>
                  </g>
                </svg>
              </div>
              <div class="answers" :style="`height: ${answered}%;`"></div>
            </div>
            <div ref="step">
              <template v-if="step === 1">
                <div class="question heading-20-500 text-center">
                  {{ questions[1].display }}
                </div>
                <div class="form pt-2">
                  <div class="pt-5 my-4">
                    <VueSlideBar
                      v-model="form.user_answers[questions[1].id]['answer']"
                      :min="0"
                      :max="50"
                    >
                      <template slot="tooltip">
                        <div class="range-tooptip"></div>
                        <div class="tooptip value">
                          {{ form.user_answers[questions[1].id]["answer"] }}
                        </div>
                      </template>
                    </VueSlideBar>
                    <div class="range-values clearfix">
                      <div class="float-left">
                        <small>0</small>
                      </div>
                      <div class="float-right">
                        <small>50</small>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="step > 1 && step <= 5">
                <div class="question heading-20-500 text-center">
                  {{ questions[step].display }}
                </div>
                <div class="form">
                  <ul class="list-unstyled">
                    <li v-for="item in answers[step]" v-bind:key="item.id">
                      <div class="custom-control custom-checkbox">
                        <input
                          type="checkbox"
                          class="custom-control-input"
                          v-model="
                            form.user_answers[questions[step].id]['answer_id'][
                              item.id
                            ]
                          "
                          :value="item.id"
                          v-bind:id="`position-` + item.id"
                        />
                        <label
                          class="custom-control-label"
                          v-bind:for="`position-` + item.id"
                          >{{ item.answer }}</label
                        >
                      </div>
                    </li>
                  </ul>
                </div>
              </template>
            </div>
          </div>
          <div hidden>
            <v-stepper ref="stepper" :steps="steps" v-model="step"></v-stepper>
          </div>
        </form>
      </div>
    </div>
    <div class="step next-btn">
      <div class="px-4 mx-2">
        <button
          v-if="step < steps"
          type="button"
          title="Volgende"
          class="btn btn-warning btn-block"
          @click="nextStep"
        >
          Volgende
        </button>
        <button
          v-if="step == steps"
          type="button"
          title="Volgende"
          class="btn btn-warning btn-block"
          @click="triggerSubmit"
        >
          Volgende
        </button>
      </div>
    </div>
    <div v-if="done" class="fullscreen-notif position-fixed">
      <div class="d-flex min-height align-items-center">
        <div class="container-fluid px-4 mx-2">
          <div class="text-center pb-1">
            <div class="icon svg mb-4 pb-1">
              <svg
                viewBox="0 0 122 106"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g transform="translate(3.000000, 3.000000)">
                    <g stroke="#625A55" stroke-width="4.2">
                      <path
                        d="M-1.77635684e-15,100 C-1.77635684e-15,80.1827237 21.0048161,64.1176471 46.9155699,64.1176471 C72.8263237,64.1176471 93.8311398,80.1827237 93.8311398,100 L-1.77635684e-15,100 Z"
                      />
                      <ellipse
                        cx="46.9155699"
                        cy="31.7647059"
                        rx="31.6680097"
                        ry="31.7647059"
                        fill="#FFCD00"
                      />
                      <path
                        d="M95.8086962,17.4085625 L108.95566,71.234468"
                        fill="#D8D8D8"
                        fill-rule="nonzero"
                        stroke-linecap="round"
                        transform="translate(102.382178, 44.321515) rotate(45.000000) translate(-102.382178, -44.321515) "
                      />
                      <polyline
                        points="28.7357866 66.4705882 46.9155699 80 64.5089086 66.4705882"
                      />
                    </g>
                    <g
                      transform="translate(38.000000, 29.000000)"
                      fill="#625A55"
                      fill-rule="nonzero"
                    >
                      <circle cx="4" cy="4" r="4" />
                      <circle cx="26" cy="4" r="4" />
                    </g>
                    <path
                      d="M42.1844298,46.3411731 C47.8510965,51.6352907 53.5177632,52.7252561 59.1844298,49.6110692"
                      stroke="#625A55"
                      stroke-width="4"
                      stroke-linecap="round"
                      transform="translate(50.684430, 48.841173) rotate(-8.000000) translate(-50.684430, -48.841173) "
                    />
                  </g>
                </g>
              </svg>
            </div>
            <div class="sd-title large text-uppercase bold text-white text-center mb-4">
              Dank voor het invullen!
            </div>
            <div class="heading-20-500">
              Nu je profiel helemaal compleet is, word je nog beter gevonden. Op naar de leukste (inval)opdrachten!
            </div>
          </div>
        </div>

        <div class="footer-btn">
          <div class="container-fluid px-4 mx-2">
            <router-link
              :to="{
                name: 'quick-step_3',
                params: { action: 'save' }
              }"
              title="Bekijk"
              class="btn btn-light btn-block"
              v-ripple="'rgba(192, 189, 187, 0.35)'"
              replace
              >Doorgaan met educatie</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VStepper } from "vue-stepper-component";
import VueSlideBar from "vue-slide-bar";

export default {
  components: {
    VStepper,
    VueSlideBar
  },
  data: function() {
    return {
      raw: "",
      years_experience: 0,
      steps: 5,
      step: 1,
      answered: 0,
      done: null,
      user: "",
      education: null,
      questions: {},
      questions_array: {},
      answers_array: {},
      answers: {},
      form: {
        user_answers: {}
      },
      prevRoute: null
    };
  },
  props: ["action"],
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData",
    step: {
      immediate: true,
      handler() {
        this.answered = Math.floor((this.step / this.steps) * 100);
      }
    },
    form: {
      handler: function() {
        localStorage.setItem("form-pending", JSON.stringify(true));
      },
      deep: true
    }
  },
  methods: {
    async fetchData() {
      await this.getQuestions();
      await this.getAnswers();
      await this.fillForm();
      localStorage.setItem("form-pending", JSON.stringify(true));
    },
    // get questions
    async getQuestions() {
      let promises = [];
      var q_url = this.$apiURI + "/question/experience/";
      var q_ctr = 1;

      //assign questions
      while (q_ctr <= this.steps) {
        promises.push(
          new Promise(resolve => {
            this.$http({
              method: "GET",
              url: q_url + q_ctr
            }).then(
              result => {
                var q_id = result.data.data[0].id;
                var q_number = result.data.data[0].number;
                this.$set(this.questions, q_number, {
                  id: result.data.data[0].id,
                  display: result.data.data[0].display
                });
                this.$set(this.questions_array, q_number, q_id);
                resolve();
              },
              error => {
                console.error(error);
              }
            );
            q_ctr++;
          })
        );
      }
      return Promise.all(promises);
    },
    //assign answers
    async getAnswers() {
      let promises = [];
      var a_url = this.$apiURI + "/answers/";
      var arr = {
        position: 2,
        audience: 3,
        education_experience: 4,
        denomination: 5
      };

      Object.keys(arr).forEach(itemKey => {
        promises.push(
          new Promise(resolve => {
            this.$http({
              method: "GET",
              url: a_url + itemKey
            }).then(
              result => {
                this.$set(
                  this.answers,
                  arr[itemKey], //qnumber
                  result.data.data
                );

                var answerIds = {};
                for (var v in result.data.data) {
                  answerIds[result.data.data[v].id] = false;
                }
                this.$set(this.answers_array, arr[itemKey], answerIds);
                resolve();
              },
              error => {
                console.error(error);
              }
            );
          })
        );
      });
      return Promise.all(promises);
    },
    async fillForm() {
      return new Promise(resolve => {
        Object.keys(this.questions_array).forEach(questionNumber => {
          var question_id = this.questions_array[questionNumber];
          if (questionNumber == 1) {
            this.$set(this.form.user_answers, question_id, {
              answer: ""
            });
          } else {
            this.$set(this.form.user_answers, question_id, {
              answer_id: this.answers_array[questionNumber]
            });
          }
        });
        resolve();
      });
    },
    triggerSubmit() {
      var elem = this.$refs.submit;
      elem.click();
    },
    async onSubmit() {
      var next = this.validateForm();
      if (next) {
        // continue
        await this.saveExperience();
        this.done = true;
        // setTimeout(
        //   () =>
        //     this.$router.replace({
        //       name: "quick-step_3",
        //       params: { action: "save" }
        //     }),
        //   5000
        // );
      }
    },
    async saveExperience() {
      return new Promise(resolve => {
        let formData = {
          user_answer: this.form["user_answers"]
        };
        localStorage.setItem("experience", JSON.stringify(formData));
        localStorage.removeItem("form-pending");
        resolve();
      });
    },
    nextStep() {
      var next = this.validateForm();
      if (next) {
        this.$refs.stepper.next();
      }
    },
    validateForm() {
      var $checkboxes = $('input[type="checkbox"]:visible');
      if ($checkboxes.length) {
        var checkedCheckboxes = $('input[type="checkbox"]:visible:checked')
          .length;
        if (!checkedCheckboxes) {
          alert("Selecteer één of meerdere antwoorden om door te gaan.");
          return false;
        }
      } else {
        return true;
      }
      return true;
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevRoute = from;
    });
  },
  beforeRouteLeave(to, from, next) {
    this.specialPending(to, from, next);
  }
};
</script>

<style scoped>
.card {
  border-radius: 5px;
  overflow: hidden;
}
.card-body {
  min-height: 135px;
}

.range-values div {
  position: relative;
  margin-top: -2px;
}
.range-values .float-left {
  left: -3px;
}
.range-values .float-right {
  right: -8px;
}

.fullscreen-notif .icon.svg svg {
  right: -22px;
}

.step-question .notification-container {
  margin-top: 25px;
}
</style>
